import { render, staticRenderFns } from "./closing-disclosure.vue?vue&type=template&id=26d1dff8"
import script from "./closing-disclosure.vue?vue&type=script&lang=js"
export * from "./closing-disclosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports